export const getUtils = () => import(
  /* webpackChunkName: "card_detail_form_store" */
  './common'
)
